import getFilterWithCol from '../../helpers/getFilterWithCol';
import tests from '../../helpers/tests';
import Types from '../../modules/types';

// Exported Field Definitions

// Warehouse Name
export const fieldName = ['FieldText', {
  name: 'name',
  label: 'Warehouse Name',
  rules: [['validation.isRequired']],
}];

// Store Selector (Visible to Admin Only)
// Store Selector (Dynamic Behavior for Admin and Seller)
export const fieldStore = ['FieldConnectionSelect', {
  name: 'store',
  placeholder: 'Select Store',
  url: '/stores/list',
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  disabled: [tests.activityIsNotCreate], // Only editable during creation
  virtual: [tests.activityIsNotCreate],
  getInitialValue: (field, props) => (
    props.data?.store
      ? props.data.store
      : !props.viewer
      ? undefined
      : props.viewer.role === 'SELLER'
      ? props.viewer.store
      : undefined
  ),
  hidden: [props => props.viewer?.role === 'SELLER'], // Hide for sellers
}];

// Country Selector
export const fieldCountry = ['FieldConnectionSelect', {
  name: 'location.country',
  label: 'Country',
  placeholder: 'Select Country',
  url: '/countries/list',
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
}];

// Address Line 1
export const fieldAddressLineOne = ['FieldText', {
  name: 'location.addressLineOne',
  label: 'Address Line 1',
  rules: [['validation.isRequired']],
}];

// Address Line 2
export const fieldAddressLineTwo = ['FieldText', {
  name: 'location.addressLineTwo',
  label: 'Address Line 2',
}];

// City
export const fieldCity = ['FieldText', {
  name: 'location.city',
  label: 'City',
  rules: [['validation.isRequired']],
}];

// Postcode
export const fieldPostcode = ['FieldText', {
  name: 'location.postcode',
  label: 'Postcode',
  rules: [['validation.isRequired']],
}];

// Phone Number
export const fieldPhoneNumber = ['FieldText', {
  name: 'location.phoneNumber',
  label: 'Phone Number',
  rules: [['validation.isRequired']],
}];

// Address Section (Nested Fields)
// export const fieldAddressSection = ['FieldTitleToggle', {
//   title: 'Address Information',
//   name: 'showAddress',
//   initialValue: true,
//   fields: [
//     fieldCountry,
//     fieldAddressLineOne,
//     fieldAddressLineTwo,
//     fieldCity,
//     fieldPostcode,
//     fieldPhoneNumber,
//   ],
// }];

// Export Fields Configuration for SELLER
export const SELLER = [
  fieldName,
  // fieldAddressSection,
      fieldCountry,
      fieldStore,
    fieldAddressLineOne,
    fieldAddressLineTwo,
    fieldCity,
    fieldPostcode,
    fieldPhoneNumber,
];

// Export Fields Configuration for ADMIN
export const ADMIN = [
  fieldName,
  fieldStore,
  // fieldAddressSection,
      fieldCountry,
    fieldAddressLineOne,
    fieldAddressLineTwo,
    fieldCity,
    fieldPostcode,
    fieldPhoneNumber,
];
